<template>
  <section class="credits full pad" v-scroll-nav="{ path: '/credits' }">
    <div class="headline">
      <h3>{{ $t('credits-title') }}</h3>
      <mq-layout :mq="'tb+'" class="tab">
        <p>{{ $t('credits-headline', { year: $config.year }) }}</p>
        <a
          :href="attachments[0].file.path[$i18n.locale]"
          :download="attachments[0].file.path[$i18n.locale]"
        >
          <button class="btn-download tx-wg-bold">
            {{ $t('download-year-pdf', { year: $config.year }) }}
          </button>
        </a>
      </mq-layout>
    </div>
    <div class="row">
      <div class="col-5 left">
        <mq-layout :mq="'tb+'" class="tab">
          <h4>{{ $t('credits-previous-editions') }}</h4>
          <p>{{ $t('credits-dropdown-title') }}</p>
        </mq-layout>
        <mq-layout :mq="['xsm', 'sm']" class="tab">
          <p>{{ $t('credits-dropdown-title-mobile') }}</p>
        </mq-layout>
        <form class="form-downloads">
          <select name="files" id="files" @change="downloadFile" v-model="file">
            <option selected="selected" :value="null">
              <p class="tx-wg-bold">{{ $t('credits-dropdown') }}</p>
            </option>
            <option
              v-for="attach in previousAttachments"
              :key="attach.id"
              :value="attach.file.path[$i18n.locale]"
            >
              <p>{{ attach.label[$i18n.locale] }}</p>
            </option>
          </select>
        </form>
      </div>
      <div class="col-5 right">
        <h4>{{ $t('credits-thanks-title') }}</h4>
        <p v-html="$t('credits-thanks-desc')"></p>
      </div>
    </div>
  </section>
</template>

<script>
import attachments from '@/assets/data/attachments';

export default {
  name: 'Credits',
  data() {
    return {
      attachments: attachments['previous-editions'],
      file: null,
      openDrop: false
    };
  },
  computed: {
    previousAttachments() {
      return this.attachments.filter((item, index) => index >= 1);
    }
  },
  methods: {
    toggleDrop() {
      this.openDrop = !this.openDrop;
    },
    downloadFile() {
      if (this.file === null) return;
      var link = document.createElement('a');
      link.href = this.file;
      link.download = this.file.split('/').pop();
      link.dispatchEvent(new MouseEvent('click'));
    }
  }
};
</script>

<style lang="scss" scoped>
.credits {
  color: $col-navy-dark;
  .headline {
    margin-bottom: $padding/2;
    @media screen and (max-width: $mq-tablet) {
      padding-top: $padding/1.5;
      margin-bottom: $padding/2;
    }
    @media screen and (max-width: $mq-mobile) {
      margin-bottom: $padding/6;
    }
    & > * {
      margin-bottom: $padding/2;
      @media screen and (max-width: $mq-tablet) {
        margin-bottom: $padding/6;
      }
    }
  }
  .btn-download {
    width: 20rem;
    height: 3.5rem;
    border-radius: 20px;
    margin: 1rem 0;
    color: $col-white;
    background-color: $col-red-light;
    &:hover {
      cursor: pointer;
    }
    @media screen and (max-width: $mq-tablet) {
      margin-bottom: $padding/4;
    }
    @media screen and (max-width: $mq-mobile) {
      width: 80%;
      margin-bottom: $padding/4;
      height: 3rem;
    }
  }
  .row {
    h4 {
      margin-bottom: $padding/4;
      @media screen and (max-width: $mq-mobile) {
        margin-bottom: $padding/6;
      }
    }
    p {
      width: 80%;
      @media screen and (max-width: $mq-mobile) {
        width: 100%;
      }
      color: $col-navy-dark;
      /deep/ a {
        color: currentColor;
      }
    }
    .left {
      .form-downloads {
        margin-top: $padding/4;
        width: 50%;
        @media screen and (max-width: $mq-mobile) {
          width: 100%;
          margin-top: $padding/4;
          margin-bottom: $padding/4;
        }
        #files {
          width: 100%;
          padding: 1rem;
          border-radius: 10px;
        }
      }
    }
    .right {
      /deep/ a {
        text-decoration: underline;
      }
      @media screen and (max-width: $mq-tablet) {
        margin-top: $padding;
      }
      @media screen and (max-width: $mq-mobile) {
        margin-top: $padding/4;
      }
    }
  }
}
</style>
